import type { RouteRecordRaw } from "vue-router";

import { getRouteParamOrEmpty, resolveAreaId } from "../utils";

export const mapRoutes: RouteRecordRaw[] = [
  {
    path: "/parkering-og-bomvei",
    name: "map",
    component: () => import(/* webpackChunkName: "dashboard-map" */ "../../components/map/MapView.vue"),
    props: route => ({ areaId: resolveAreaId(route) }),
    meta: { titleKey: "pageTitle.map", layout: "map", resetScroll: true, viewGroup: "map" }
  },
  {
    path: "/parkering",
    name: "map-parking",
    component: () => import(/* webpackChunkName: "dashboard-map" */ "../../components/map/MapView.vue"),
    props: () => ({}),
    meta: {
      titleKey: "pageTitle.mapParking",
      layout: "map",
      resetScroll: true,
      viewGroup: "map"
    }
  },
  {
    path: "/bomvei",
    name: "map-toll",
    component: () => import(/* webpackChunkName: "dashboard-map" */ "../../components/map/MapView.vue"),
    props: () => ({}),
    meta: { titleKey: "pageTitle.mapToll", layout: "map", resetScroll: true, viewGroup: "map" }
  },
  {
    path: "/map/area/:areaId",
    name: "map-area-details",
    component: () =>
      import(/* webpackChunkName: "dashboard-map-area-details" */ "../../components/map/AreaDetailsView.vue"),
    props: route => ({
      areaId: getRouteParamOrEmpty(route, "areaId")
    }),
    meta: { titleKey: "pageTitle.map", layout: "map", resetScroll: true, viewGroup: "map" }
  },
  {
    path: "/map/:areaId",
    name: "map-area",
    component: () => import(/* webpackChunkName: "dashboard-map" */ "../../components/map/MapView.vue"),
    props: route => ({
      areaId: resolveAreaId(route),
      lotId: typeof route.query.lot === "string" ? route.query.lot : undefined
    }),
    meta: { titleKey: "pageTitle.map", layout: "map", resetScroll: true, viewGroup: "map" }
  },
  {
    path: "/map/lot/:lotId",
    name: "map-lot-details",
    component: () =>
      import(/* webpackChunkName: "dashboard-map-area-details" */ "../../components/map/AreaDetailsView.vue"),
    props: route => ({
      lotId: getRouteParamOrEmpty(route, "lotId")
    }),
    meta: { titleKey: "pageTitle.map", layout: "map", resetScroll: true, viewGroup: "map" }
  }
];
